import { Link, NavLink } from "react-router-dom";
import logo from "./logo192.png";
import { useAuthContext } from "../hooks/useAuthContext";
import { useLogout } from "../hooks/useLogout";
import { useEffect, useState } from "react";
import { msmartAxios } from "../api/axios";
import { subscribePush } from "../utils/subscribePush";
import { usePWAInstallPrompt } from "../hooks/usePWAInstallPrompt";
import { usePushStatus } from "../context/PushStatusContext";
import { useToast } from "../context/ToastContext";

function Navbar() {
  const { logout } = useLogout();
  const { user } = useAuthContext();
  const { isSubscribed, loading, setIsSubscribed, setLoading } = usePushStatus();
  const [teamId, setTeamId] = useState(null);
  const { deferredPrompt, isInstalled } = usePWAInstallPrompt();
  const { notifySuccess, notifyError, notifyLoading } = useToast();

  const noTraining = ["27"];
  const canShowTraining = user && teamId && !noTraining.includes(String(teamId));

  const closeMenu = () => {
    const el = document.getElementById("hamburger");
    if (el) el.checked = false; // better than click()
  };

  const handleLogout = () => {
    closeMenu();
    logout();
  };

  const handleSubscribe = async () => {
    const toastId = notifyLoading("Subscribing to notifications...");
    try {
      const result = await subscribePush(user);

      if (result?.success) {
        setIsSubscribed(true);
        notifySuccess("Subscribed to notifications.", { id: toastId });

        // close modal + menu
        const closeBtn = document.getElementById("closeSub");
        if (closeBtn) closeBtn.click();
        setTimeout(() => closeMenu(), 200);
      } else {
        notifyError("Failed to subscribe: " + (result?.error || "Unknown error"), {
          id: toastId,
        });
      }
    } catch (e) {
      notifyError("Failed to subscribe. Please try again.", { id: toastId });
    }
  };

  const handleInstallClick = async () => {
    try {
      if (deferredPrompt) {
        deferredPrompt.prompt();
      }
    } catch (e) {
      // silent fail
    }
  };

  useEffect(() => {
    let mounted = true;

    async function fetchTeam() {
      if (!user?.token) return;
      try {
        const response = await msmartAxios.get("/api/msmart/get/user/team", {
          headers: { accessToken: user.token },
        });
        if (!mounted) return;

        if (response.status === 201) {
          setTeamId(response.data.teamId);
        }
      } catch (e) {
        if (mounted) setTeamId(null);
      }
    }

    fetchTeam();
    return () => {
      mounted = false;
    };
  }, [user?.token]);

  return (
    <>
      <div className="topnav">
        <div className="topnav-conteiner conteiner">
          <Link to="/" className="d-flex align-items-center gap-2 text-decoration-none">
            <img alt="Mirads Marketing" className="logo" src={logo} height="40" />
          </Link>

          <input type="checkbox" id="hamburger" />

          <div className="hamburger-lines" aria-label="Menu">
            <span className="line line1"></span>
            <span className="line line2"></span>
            <span className="line line3"></span>
          </div>

          <div className="menu-items">
            {!user && (
              <>
                <Link to="/login" onClick={closeMenu}>
                  Sign In
                </Link>
              </>
            )}

            {user && (
              <>
                <NavLink to="/" onClick={closeMenu}>
                  Home
                </NavLink>

                <NavLink to="/msmart" onClick={closeMenu}>
                  M-Smart
                </NavLink>

                {canShowTraining && (
                  <NavLink to="/courses" onClick={closeMenu}>
                    Training Centre
                  </NavLink>
                )}

                <Link to="/login" onClick={handleLogout}>
                  Logout ({user.username})
                </Link>

                {/* Action icons (modern chips) */}
                {isInstalled && (
                  <button
                    type="button"
                    className="ds-icon-btn"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    title="Notifications"
                    onClick={closeMenu}
                  >
                    <i className="bi bi-bell-fill"></i>
                  </button>
                )}

                {!isInstalled && deferredPrompt && (
                  <button
                    type="button"
                    className="ds-icon-btn"
                    onClick={handleInstallClick}
                    title="Install app"
                  >
                    <i className="bi bi-cloud-arrow-down-fill"></i>
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content ds-modal">
            <div className="text-end" style={{ paddingTop: "10px", paddingRight: "10px" }}>
              <button
                id="closeSub"
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body text-center m-3">
              <div>
                <i className="bi bi-bell-fill" style={{ fontSize: "3rem" }}></i>
              </div>

              <div className="mb-2" style={{ textTransform: "uppercase", fontSize: "1.2rem", fontWeight: "800" }}>
                Get notified
              </div>

              <div className="mb-3 text-muted" style={{ textTransform: "capitalize" }}>
                When you set a new follow-up reminder
              </div>

              <div className="d-grid gap-2 mt-3">
                {loading ? (
                  <button className="btn btn-secondary" disabled>
                    Checking...
                  </button>
                ) : isSubscribed ? (
                  <button className="btn btn-outline-success" disabled>
                    <i className="bi bi-check-lg"></i> Subscribed
                  </button>
                ) : (
                  <button className="btn btn-dark" onClick={handleSubscribe}>
                    Subscribe Now
                  </button>
                )}
              </div>

              <div className="text-muted mt-3" style={{ fontSize: 12 }}>
                You can unsubscribe anytime from browser notification settings.
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;
